import React, { FC, useState } from 'react';
// import { Box, BoxProps, Popover, Typography } from '@mui/material';
import { gql, useMutation, useQuery } from '@apollo/client';
// import Image from 'next/legacy/image';
// import JWButton from 'src/components/JW/JWButton/JWButton';
// import Loading from 'src/components/Loading';
// import sentryCaptureException from 'src/utils/sentryCaptureException';
// import { useIsAdmin } from 'src/functions/isAdmin';
import {
  BoxProps,
  Box,
  Typography,
  Popover,
  makeStyles,
} from '@material-ui/core';
import JWButton, {
  COLOR_ICON,
  COLOR_MAIN_GREY,
  COLOR_TEXT_TEXT,
} from './JW/JWButton';
import { CircularLoading } from 'appDir/lib/components/Loading';
import JWHr from './JW/JWHr';

interface NameCircleProps extends BoxProps {
  name: string;
  height?: number;
  bgcolor?: string;
}

const NameCircle: FC<NameCircleProps> = ({
  name,
  height = 24,
  bgcolor = '#048CDD',
  ...props
}) => (
  <Box
    bgcolor={bgcolor}
    borderRadius="100%"
    display="flex"
    alignItems="center"
    justifyContent="center"
    height={height}
    width={height}
    {...props}
  >
    <Typography variant="body1" style={{ lineHeight: '14px', color: '#fff' }}>
      {name.charAt(0)}
    </Typography>
  </Box>
);

const useStyles = makeStyles({
  openButton: (props: any) => {
    return {
      cursor: 'pointer',
      '.appbar-profile-arrow': {
        color: props.anchorEl ? '#048CDD' : '#D3D6E9',
        transition: 'all 200ms ease-in-out',
        transform: props.anchorEl ? 'rotate(180deg)' : 'rotate(0deg)',
      },
    };
  },
});

export interface ProfileProps {
  data: any;
}

const Profile: FC<ProfileProps> = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const classes = useStyles({ anchorEl });
  const [signOutUser, { loading: signOutUserLoading }] = useMutation(
    gql`
      mutation SignOutUser {
        signOutUser {
          userId
        }
      }
    `
  );
  // const isAdmin = useIsAdmin();
  const isAdmin = true;
  // HOOKS END

  const { email, imageUrl, name, provider } = data.currentUser!;

  const handleSignOutClick = async (e: any) => {
    e.preventDefault();
    try {
      const res = await signOutUser();
      window.location.href = '/';
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box position="relative">
      <Box
        display="flex"
        alignItems="center"
        px="15px"
        onClick={(e: any) => setAnchorEl(e.currentTarget)}
        className={classes.openButton}
      >
        <NameCircle name={name} height={34} mr="20px" />
        <Box>
          <Box
            style={{
              color: '#535453',
              fontFamily: 'Gotham Rounded',
              fontSize: '14px',
              lineHeight: '17px',
              fontWeight: 350,
            }}
          >
            {name}
          </Box>
          <Box
            style={{
              fontFamily: 'sans-serif',
              fontSize: '13px',
              lineHeight: '18px',
              fontWeight: 500,
              letterSpacing: '0.04rem',
              color: '#657197',
            }}
          >
            {email}
          </Box>
        </Box>
        <svg
          className="appbar-profile-arrow"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 11L12 14L8 11"
            stroke={COLOR_ICON}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        // PaperProps={{ sx: { mt: '25px', borderRadius: '15px' } }}
        PaperProps={{ style: { marginTop: '25px', borderRadius: '15px' } }}
        // BackdropProps={{ invisible: true }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box padding="30px 30px 18px" textAlign="center">
          <NameCircle name={name} height={74} margin="auto" />
          <Typography
            variant="h4"
            style={{
              color: COLOR_MAIN_GREY,
              margin: 0,
              marginTop: '20px',
              fontFamily: 'Gotham Rounded,Helvetica,Arial,sans-serif',
              fontWeight: 'bold',
              fontSize: '18px',
              lineHeight: '22px',
              letterSpacing: '0.00735em',
            }}
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            style={{ marginTop: '6px', color: COLOR_TEXT_TEXT }}
          >
            {email}
          </Typography>
          <JWHr style={{ marginTop: '30px' }} />
          {isAdmin && (
            <JWButton
              jwType="basic"
              style={{ marginTop: '18px' }}
              href="/admin/updates"
            >
              Updates
            </JWButton>
          )}
          {!provider && (
            <JWButton
              jwType="basic"
              style={{ marginTop: '18px' }}
              href="/users/edit"
            >
              Change Email/Password
            </JWButton>
          )}
          <JWButton
            jwType="basic-red"
            style={{ marginTop: '18px' }}
            onClick={handleSignOutClick}
          >
            Sign Out
          </JWButton>
        </Box>
      </Popover>
      {signOutUserLoading && <CircularLoading />}
    </Box>
  );
};

export interface ProfileContainerProps extends Omit<ProfileProps, 'data'> {}

const ProfileContainer: FC<ProfileContainerProps> = ({ ...props }) => {
  const { data } = useQuery(
    gql`
      query UserProfile {
        currentUser {
          id
          email
          imageUrl
          name
          provider
        }
      }
    `
  );
  if (!data) return null;
  return <Profile data={data} {...props} />;
};

export default ProfileContainer;
